import React from 'react';

export default function Spinner({ className = '' }) {
  return (
    <div className={`flex items-center justify-center ${className}`} role="status" aria-label="Loading">
      <div className="animate-spin rounded-full h-8 w-8 border-2 border-gray-200 border-t-teal-600" />
    </div>
  );
}
